import {
  Component,
  computed,
  DestroyRef,
  inject,
  input,
  isSignal,
  OnDestroy,
  OnInit,
  output,
  Renderer2,
  signal,
  WritableSignal,
} from '@angular/core';

import { NbStatusService } from '@nebular/theme';

import { TInsertedToast, TToastText } from '../toast.types';

import { ToastConfig } from './toast-config.class';

@Component({
  template: ``,
  host: {
    class: 'sui-toast',
    '[class]': 'getClasses()',
    '[class.has-title]': '!!toast().title',
    '[class.has-icon]': '!!this.icon',
    '[class.destroy-by-click]': 'toast().config.destroyByClick',
    '(click)': 'onClick()',
  },
})
export abstract class ToastComponent<Config extends ToastConfig = ToastConfig> implements OnInit, OnDestroy {
  toast = input.required<TInsertedToast<Config>>();

  clickEvent = output<string>();

  destroyEvent = output<void>();

  get config(): Config {
    return this.toast().config;
  }

  get instance() {
    return this;
  }

  protected readonly renderer = inject(Renderer2);

  protected readonly statusService = inject(NbStatusService);

  protected readonly destroyRef = inject(DestroyRef);

  protected title = signal<string>('');

  protected message = signal<string>('');

  protected icon = computed(() => {
    const { icon, hasIcon } = this.config;

    if (!icon || !hasIcon) return null;

    return typeof icon === 'object' ? icon.icon : icon;
  });

  ngOnDestroy() {
    this.destroyEvent.emit();
  }

  abstract ngOnInit(): void;

  protected onClick() {
    this.clickEvent.emit(this.toast()!.id);
  }

  protected getClasses() {
    const status = this.config.status;
    const customClass = this.config.toastClass || '';

    return [this.statusService.getStatusClass(status) || '', customClass];
  }

  protected setCommonData() {
    this.setText(this.toast().title, this.title);
    this.setText(this.toast().message, this.message);
  }

  protected setText(text: TToastText, target: WritableSignal<string>) {
    if (isSignal(text)) {
      target = text as WritableSignal<string>;
    } else {
      target.set(text);
    }
  }
}
